import { useState } from "react";
import { Alert, Stack } from "@mui/joy";
import { useLogoutWithoutRouter } from "../../hooks/useLogout";
import { Quiet } from "../documents/design/Quiet";

/** Outside protected content, inside the identity providers and above every router: the
 *  desktop mounts admission above its per-tab routers, so this control signs out by a full
 *  load and never asks for one (hp, 2026-10-21: a window went blank after waking). */
export function AccessRecoverySignOut() {
    const logout = useLogoutWithoutRouter();
    const [pending, setPending] = useState(false);
    const [failed, setFailed] = useState(false);
    const signOut = async () => {
        setPending(true);
        setFailed(false);
        try {
            await logout({ hardRedirect: true });
        } catch {
            setFailed(true);
            setPending(false);
        }
    };
    return (
        <Stack gap={1}>
            <Quiet disabled={pending} onClick={signOut}>
                {pending ? "Signing out…" : "Sign out and sign in again"}
            </Quiet>
            {failed && (
                <Alert color="warning">
                    Sign-out did not complete. Retry to clear this session before signing in again.
                </Alert>
            )}
        </Stack>
    );
}
